import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@/shared/shared.module';

import { TwitchComponent } from '@components/stream/twitch/twitch.component';
import { YoutubeComponent } from '@components/stream/youtube/youtube.component';
import { VimeoComponent } from '@components/stream/vimeo/vimeo.component';
import { NhlComponent } from '@components/stream/nhl/nhl.component';
import { ISportComponent } from '@components/stream/isport/isport.component';
import { TvComComponent } from '@components/stream/tvcom/tvcom.component';

const STREAM_COMPONENTS = [
    TwitchComponent,
    YoutubeComponent,
    VimeoComponent,
    NhlComponent,
    ISportComponent,
    TvComComponent,
];

@NgModule({
    declarations: STREAM_COMPONENTS,
    imports: [CommonModule, SharedModule],
    exports: STREAM_COMPONENTS,
})
export class StreamModule {}
